// Welcome video player — replaces testimonial carousel
document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelector('.welcome-video-wrapper');
    if (!wrapper) return;

    const video = wrapper.querySelector('.welcome-video');
    const btn = wrapper.querySelector('.video-play-btn');

    // Sync button visibility to actual video state via events
    video.addEventListener('play', () => btn.classList.add('is-playing'));
    video.addEventListener('pause', () => btn.classList.remove('is-playing'));
    video.addEventListener('ended', () => btn.classList.remove('is-playing'));

    // Click anywhere on the wrapper (button clicks bubble up here too)
    wrapper.addEventListener('click', () => {
        if (video.paused || video.ended) {
            const p = video.play();
            if (p !== undefined) {
                p.catch((err) => {
                    console.warn('Video play failed:', err);
                    btn.classList.remove('is-playing');
                });
            }
        } else {
            video.pause();
        }
    });
});
